import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faClock,
  faArrowLeft,
  faArrowRight,
  faCheckCircle,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import './QuestionDisplay.css';

const QuestionDisplay = ({
  question,
  questionIndex,
  totalQuestions,
  selectedAnswer,
  onAnswerChange,
  onNext,
  onPrevious,
  onSubmit,
  isFirstQuestion,
  isLastQuestion,
  onAnswerSelected,
  isTimedOut
}) => {



  if (!question) {
    return (
      <div className="question-display-error">
        <FontAwesomeIcon icon={faExclamationCircle} />
        <p>Question not found</p>
      </div>
    );
  }

  return (
    <div className="question-display-container">
      {/* Question Header */}
      <div className="question-header">
        <div className="question-info">
          <h2>Question {questionIndex + 1} of {totalQuestions}</h2>
          {question.maxQuestionAttempts && (
            <div className="question-attempts">
              <span className="attempt-info">
                Attempt: {question.attemptNum || 1} / {question.maxQuestionAttempts}
              </span>
            </div>
          )}
        </div>
        
        <div className="question-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${((questionIndex + 1) / totalQuestions) * 100}%` }}
            />
          </div>
          <span className="progress-text">
            {Math.round(((questionIndex + 1) / totalQuestions) * 100)}% Complete
          </span>
        </div>
      </div>

      {/* Question Content */}
      <div className="question-content">
        <div className="question-text">
          {question.questionText}
        </div>

        {/* Answer Options */}
        <div className="answer-options">
          {question.dlTrainingCompetencyQuestionAnswers?.map((answer) => (
            <label key={answer.answerId} className="answer-option">
              <input
                type="radio"
                name={`question_${question.questionId}`}
                value={answer.answerId}
                checked={selectedAnswer === answer.answerId}
                onChange={() => {
                  onAnswerChange(answer.answerId);
                  if (onAnswerSelected) {
                    onAnswerSelected(question.questionId, answer.answerId);
                  }
                }}
              />
              <span className="answer-text">{answer.answerText}</span>
              <span className="radio-checkmark"></span>
            </label>
          ))}
        </div>
      </div>

      {/* Navigation */}
      <div className="question-navigation">
        <button
          type="button"
          onClick={onPrevious}
          disabled={isFirstQuestion}
          className="btn-nav btn-secondary"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          {isTimedOut ? "Submit" : "Previous"}
        </button>

        <div className="question-counter">
          Question {questionIndex + 1} of {totalQuestions}
          {isTimedOut && <div className="timeout-warning">Time's up! Please submit.</div>}
        </div>

        {!isLastQuestion && !isTimedOut ? (
          <button
            type="button"
            onClick={onNext}
            disabled={!selectedAnswer}
            className="btn-nav btn-primary"
          >
            Next
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        ) : (
          <button
            type="button"
            onClick={onSubmit}
            className={`btn-nav ${isTimedOut ? 'btn-warning' : 'btn-success'}`}
            disabled={!isTimedOut && !selectedAnswer}
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            {isTimedOut ? "Submit (Time Up)" : "Submit"}
          </button>
        )}
      </div>
    </div>
  );
};

export default QuestionDisplay;